import React, { useState, useRef } from "react";
import {
  MoonLoader,
  ClipLoader,
  BarLoader,
  BeatLoader,
  BounceLoader,
  CircleLoader,
  ClockLoader,
  DotLoader,
  FadeLoader,
  GridLoader,
  HashLoader,
  PropagateLoader,
  PuffLoader,
  PulseLoader,
  RingLoader,
  RotateLoader,
  ScaleLoader,
  SkewLoader,
  SquareLoader,
  SyncLoader,
} from "react-spinners";

export function TutorialContainer({ type = "image", url }) {
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef();

  const handleMediaLoad = (ev) => {
    setIsLoading(false);
    if (type === "video" && videoRef.current) {
      videoRef.current.play();
    }
  };

  return (
    <div className="chronos-tutorial-container">
      {type === "image" && <img className="chronos-tutorial-image" src={url} />}
      {type === "video" && (
        <video
          ref={videoRef}
          onLoadedData={handleMediaLoad}
          className="chronos-tutorial-video"
          src={url}
          // autoPlay
          muted
          loop
          width="100%"
        />
      )}
      <div
        className={
          "chronos-tutorial-loading-overlay" +
          (!isLoading ? ` done-loading` : "")
        }
      >
        <div className="chronos-tutorial-loader-content">
          <div className="chronos-tutorial-loader-text">Loading</div>
          <PropagateLoader loading color="#918264" />
        </div>
      </div>
    </div>
  );
}
